export const CONFIGURE_APP_MODES = {
  GENERAL: 'general',
  PROVISIONING_GENERATE_KEY: 'provisioning_generate_key',
} as const;

export const WAIT_UNTIL_CODE_IS_FETCHED = 10;
